import { ContactContainer } from "../../containers";
import './style.scss'

function Contact() {
    return (
        <div id="contact">
            <ContactContainer />
        </div>
    );
}
export default Contact;